import { useTranslation } from "react-i18next";
import { useState } from "react";
import { PageLayout } from "../../Components/PageLayout";
import { VehicleTabs } from "../../Components/Tables/Vehicles/Tabs";
import { TablePlaceHolder } from "../../Components/LoadingAnimations/LoadingAnimations";
import TrailersBacklogTable from "./Tables/Trailers/Trailers";
import TrucksBacklogTable from "./Tables/Trucks/Trucks";
import VisitorsBacklogTable from "./Tables/Visitors/Visitors";

const BacklogView = () => {
  const { t } = useTranslation();

  const tabs = ["Trailers", "Trucks", "Visitors"];
  const [selectedTab, setSelectedTab] = useState("Trailers");

  return (
    <PageLayout title={"Backlog"}>
      <div className="inventory-header">
        <h2 className="global-h1 light-black">{t("page-headers.backlog")}</h2>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <VehicleTabs
          tabs={tabs}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />

      </div>
      {selectedTab === "Trailers" ? (
        <TrailersBacklogTable/>
      ) : selectedTab === "Trucks" ? (
        <TrucksBacklogTable/>
      ) : selectedTab === "Visitors" ? (
        <VisitorsBacklogTable/>
      ) : (
        <TablePlaceHolder />
      )}
    </PageLayout>
  );
}

export default BacklogView;